/**
 * Helpers de configuration conserves pour les vues d'administration.
 *
 * La normalisation elle-meme vit dans `core/config` : ce fichier se contente
 * d'en exposer la forme enveloppee attendue par l'API.
 */

import { HtmlCssConfig } from '../../../models/htmlcss/types';
import { getDefaultConfigContent, normalizeConfigContent } from '../core/config';

/** Configuration complete par defaut, prete a etre enregistree. */
export const getDefaultConfig = (): HtmlCssConfig => ({
  lesson_id: 0,
  config: getDefaultConfigContent(),
});

/** Ramene une configuration quelconque a la forme attendue par l'API. */
export const toHtmlCssConfig = (raw: unknown, lessonId: number): HtmlCssConfig => {
  const wrapper = (raw ?? {}) as { lesson_id?: number; config?: unknown };
  const inner = wrapper.config !== undefined ? wrapper.config : raw;

  return {
    lesson_id: wrapper.lesson_id ?? lessonId,
    config: normalizeConfigContent(inner),
  };
};
